/**
 * Los textos de los formularios de la biblioteca, en el idioma del sitio.
 *
 * Los templates se escriben en inglés neutro (un solo idioma para todos), y un
 * formulario guarda sus textos tal cual —«Name», «Send message»—: no pasan por
 * la IA, que escribe los de la sección. En un sitio en español salían en
 * inglés. Como los templates son nuestros y en inglés, basta con traducir las
 * frases que traen; una que no esté aquí se queda como está, y una etiqueta
 * escrita a mano por el dueño no se parece a ninguna.
 */
const ES = {
    Contact: 'Contacto',
    Newsletter: 'Boletín',
    'Quote request': 'Solicitud de presupuesto',
    Name: 'Nombre',
    'Full name': 'Nombre completo',
    Email: 'Correo',
    Phone: 'Teléfono',
    Message: 'Mensaje',
    Company: 'Empresa',
    'What do you need?': '¿Qué necesitas?',
    'Send message': 'Enviar mensaje',
    Send: 'Enviar',
    Subscribe: 'Suscribirme',
    'Get my quote': 'Pedir presupuesto',
    'Thanks! We will be in touch soon.': '¡Gracias! Te contactaremos pronto.',
    'You are in! Check your inbox to confirm.': '¡Listo! Revisa tu correo para confirmar.',
    'Thanks! We will reply within one business day.': '¡Gracias! Te respondemos en un día hábil.',
};
const BY_LANGUAGE = { es: ES };
/** Un texto de formulario de la biblioteca en ese idioma; el mismo si no se conoce. */
export function formTextIn(language, text) {
    return (language && BY_LANGUAGE[language]?.[text.trim()]) || text;
}
/** El formulario entero —nombre, campos, botón y aviso— en ese idioma. */
export function localizeForm(form, language) {
    if (!language || !BY_LANGUAGE[language])
        return form;
    const text = (value) => (typeof value === 'string' && value ? formTextIn(language, value) : value);
    const fields = Array.isArray(form.fields)
        ? form.fields.map((field) => {
            const bag = (field && typeof field === 'object' ? field : {});
            return { ...bag, label: text(bag.label), ...(typeof bag.placeholder === 'string' ? { placeholder: text(bag.placeholder) } : {}) };
        })
        : form.fields;
    return { ...form, name: text(form.name), submitLabel: text(form.submitLabel), successMessage: text(form.successMessage), fields };
}
//# sourceMappingURL=templateFormText.js.map